import React, { useState, useEffect } from "react"
import { Link } from "@reach/router"
import Airtable from "airtable"
import M from "materialize-css"
import "../styles/App.scss"
//Components
import ComplianceHeader from "../components/ComplianceHeader.jsx"
import Footer from "../components/Footer.jsx"
//Utils
import tableNumbers from "../utils/tableNumbers"

const provider = ""

const NonCompliance = props => {
  const [elems, setElems] = useState([])
  //Para almacenar las notas creamos un estado
  const [note, setNote] = useState("")
  const [elem, setElem] = useState({})
  //Estado para almacenar la Semana índicada
  const [selected, setSelected] = useState(26)
  // Estado que controla los input del dropdown
  const [week, setWeek] = useState("")
  // Almácen de número de semanas
  // Almácen de número de semanas
  const [weeks, setWeeks] = useState(tableNumbers)
  // Control de indices para el iterador de elementos
  const [index, setIndex] = useState(0)

  // API request to weeks quantity
  const getWeeks = () => {
    fetch(`${provider}/fetch-data/building/${props.page}/weeks/`)
      .then(res => res.json())
      .then(data => {
        setWeeks(data.weeks.reverse())
      })
  }

  // Método para comunicar a sidenav un cambio en el dropdown
  const handleChange = event => {
    setWeek(event.target.value)
    setIndex(event.target.value - 1)
    setSelected(() => event.target.value)
  }

  // API Request para notas de cumplimiento
  const request = () => {
    let base = new Airtable({ apiKey: "keyRICOfYlRaLgFzw" }).base(
      "appLpc9Ewre2aXiiz"
    )

    base(`Semana ${selected}`)
      .select({
        filterByFormula: `{OBRA} = "${props.project}"`,
        // 1 obra por el número de registros total:
        maxRecords: 1,
        view: "Grid view",
      })
      .eachPage(
        function page(records, fetchNextPage) {
          // This function (`page`) will get called for each page of records.
          let store = []

          records.forEach(function (record) {
            for (
              let i = 0;
              i < record.get("EVIDENCIA DE INCUMPLIMIENTO").length;
              i++
            ) {
              store.push(record.get("EVIDENCIA DE INCUMPLIMIENTO")[i].url)
            }
          })

          setElems(store)

          fetchNextPage()
        },
        function done(err) {
          if (err) {
            console.error(err)
            return
          }
        }
      )
  }

  //API Request para notas de incumplimiento
  const noteRequest = () => {
    let base = new Airtable({ apiKey: "keyRICOfYlRaLgFzw" }).base(
      "appLpc9Ewre2aXiiz"
    )

    base(`Semana ${selected}`)
      .select({
        filterByFormula: `{OBRA} = "${props.project}"`,
        // 1 obra por el número de registros total:
        maxRecords: 1,
        view: "Grid view",
      })
      .eachPage(
        function page(records, fetchNextPage) {
          // This function (`page`) will get called for each page of records.
          records.forEach(function (record) {
            setNote(record.get("NOTAS DE INCUMPLIMIENTO"))
          })

          fetchNextPage()
        },
        function done(err) {
          if (err) {
            console.error(err)
            return
          }
        }
      )
  }

  useEffect(() => {
    request()
    noteRequest()
    // Carga el evento para las imagenes
    let elems = document.querySelectorAll(".materialboxed")
    M.Materialbox.init(elems, 200)

    let elem = document.querySelector(".materialboxed")
    M.Materialbox.getInstance(elem)
  }, [selected, setSelected])

  return (
    <>
      <ComplianceHeader
        //getWeeks={getWeeks}
        handleChange={handleChange}
        weeks={weeks}
        week={week}
        page={props.page}
      />
      {/* Notas de Incumplimiento */}
      <div className="note-compliance">
        <h1>{elem.week && elem.week.building_lot.building_name}</h1>
        <h1>Notas de Incumplimiento</h1>
        <div className="note-container">
          <ul>
            <li>{note}</li>
          </ul>
        </div>
        <div className="evidences">
          <div className="evidence">
            <img
              className="evidence-img materialboxed"
              src={`${elems[0]}`}
              alt="evidencia"
            />
            <img
              className="evidence-img materialboxed"
              src={`${elems[1]}`}
              alt="evidencia"
            />
            <img
              className="evidence-img materialboxed"
              src={`${elems[2]}`}
              alt="evidencia"
            />
          </div>
          <div className="evidence">
            <img
              className="evidence-img materialboxed"
              src={`${elems[3]}`}
              alt="evidencia"
            />
            <img
              className="evidence-img materialboxed"
              src={`${elems[4]}`}
              alt="evidencia"
            />
            <img
              className="evidence-img materialboxed"
              src={`${elems[5]}`}
              alt="evidencia"
            />
          </div>
        </div>
      </div>
      <span className="directions">
        <Link to={`/building/${props.page}`}>&larr; Regresar</Link>
        <Link to="/kila-home-id-980615">
          Ir a inicio{" "}
          <span role="img" aria-label="house">
            &nbsp;🏠
          </span>
        </Link>
      </span>
      <Footer />
    </>
  )
}

export default NonCompliance
